module.exports = __webpack_public_path__ + "static/media/billing.3abb0b96.svg";